import * as React from 'react';

import * as styles from './styles.css';

export const InlineParam: React.StatelessComponent<{}> = props => (
  <div className={styles['inline-param']}>{props.children}</div>
);

export const InlineLabel: React.StatelessComponent<{}> = props => (
  <div className={styles['inline-label']}>{props.children}</div>
);
